import { render, staticRenderFns } from "./jdyj.vue?vue&type=template&id=d8372792&scoped=true&"
import script from "./jdyj.vue?vue&type=script&lang=js&"
export * from "./jdyj.vue?vue&type=script&lang=js&"
import style0 from "./jdyj.vue?vue&type=style&index=0&id=d8372792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8372792",
  null
  
)

export default component.exports